module.exports = __webpack_public_path__ + "media/images/screen_hello-d08d3eac890211eaa3ae6d75639787dd.svg";